<div class="modal-header">
  <h4 class="modal-title">On-Demand Request Warning</h4>
</div>

<div class="modal-body">
  <p>
    <strong>{{ request.Region }}</strong> is a buildout region. Access and quota requests for such regions must be declarative and automated.
    Please visit <a href="https://aka.ms/catseye-docs">this wiki</a> to learn more about the options.
  </p>

  <div class="form-check">
    <input type="checkbox"
           id="confirmCheckbox"
           class="form-check-input"
           #checkbox
           (change)="onCheckboxChange(checkbox.checked)" />
    <label class="form-check-label" for="confirmCheckbox">
      I consent that I'm submitting this On-Demand request from the UI for a break-glass scenario.
      My team will onboard <a href="https://aka.ms/catseye-docs">Service Blueprint</a> and adopt automation going forward.
    </label>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="activeModal.dismiss()">Cancel</button>
  <button type="button"
          class="btn btn-danger"
          [disabled]="!isConfirmed"
          (click)="activeModal.close()">
    Continue
  </button>
</div>
